<template>
  <div class="jps-curation-list-imagewide-view" :class="imageClass">
    <div
      class="jps-image-viewwide-element"
      v-for="item in items"
      :key="item.key"
    >
      <UiButtonIcon
        tag="button"
        v-if="editable"
        class="jps-icon-button list-delete"
        @click.stop="emits('delete-item', item)"
        icon="mdi/close-circle"
      />
      <template v-if="!item.readNext">
        <div class="jps-image-view-image jps-relative">
          <BaseLink
            class="image-link"
            v-bind="baseLinkProps(item)"
            @click="emits('show-modal', item)"
            :show-icon="false"
          >
            <UiImageSelection
              :image="item.image"
              image-usage="thumbnail"
            />
          </BaseLink>
          <ListEditIcon :item="item" field="image" :editstate="editstate" />
        </div>
        <div class="jps-image-view-element-desc">
          <h3
            class="jci-caption is-size-6-desktop is-size-7-touch has-text-weight-bold"
          >
            <BaseLink
              v-bind="baseLinkProps(item)"
              @click="emits('show-modal', item)"
            >
              {{ ls(item.title) }}
              <ListEditIcon :item="item" field="title" :editstate="editstate" />
              <ListEditIcon :item="item" field="url" :editstate="editstate" />
              <ListEditIcon :item="item" field="linkUrl" :editstate="editstate" />
            </BaseLink>
          </h3>
          <div class="jci-description-text is-size-6-desktop is-size-7-touch">
            {{ ls(item.description) }}
            <ListEditIcon :item="item" field="description" :editstate="editstate" />
          </div>
        </div>
      </template>
      <SearchResultDiv v-else :item="item" :editstate="editstate" />
    </div>
    <div class="list-add-div" v-if="editable && !isNote">
      <button
        class="jps-icon-button list-add-button jps-sub-orange"
        @click="emits('add')"
      >
        <BaseIcon name="mdi/plus-circle" :alt="ls(addPartMsg)" size="size-4" />
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { ls } = useI18n()

interface Props {
  editstate?: CurationEditState
  def : PartList
  items: ListElement[]
}
const props = withDefaults(defineProps<Props>(), {})

const emits = defineEmits(['delete-item', 'show-modal', 'add'])

const {
  isNote,
  hasExternalLink,
  baseLinkProps,
  editable,
  addPartMsg,
} = useCurationListView(props.editstate, props.def)

const imageClass = computed(() => {
  return "jps-ilview-" + Math.min(3, props.items.length)
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-curation-list-imagewide-view {
  margin-bottom: 1rem;
  display: flex;

  &.jps-ilview-1 {
    .jps-image-viewwide-element {
      width: 100%;
    }
  }
  &.jps-ilview-2 {
    .jps-image-viewwide-element {
      width: 50%;
    }
  }
  &.jps-ilview-3 {
    flex-wrap: wrap;
    .jps-image-viewwide-element {
      width: 33%;
    }
  }

  @include is-mobile() {
    &.jps-ilview-1,
    &.jps-ilview-2,
    &.jps-ilview-3 {
      .jps-image-viewwide-element {
        width: 100%;
      }
    }
  }

  .jps-image-viewwide-element {
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 1rem;
    position: relative;
    min-height: 6rem;
    .list-delete {
      position: absolute;
      top: 2px;
      left: 18px;
      z-index: 1000;
      background: $jps-gray-50;
    }
    .jps-image-view-image {
      height: 380px;
      cursor: pointer;
      .image-link {
        width: 100%;
        height: 100%;
      }
      .jps-image-selection {
        background: $white;
      }
    }
    .jps-image-view-element-desc {
      padding: 0.75rem 0.5rem;
      .jci-caption {
        @include typo-list();
        a {
          display: block;
        }
      }
      .jci-description-text {
        @include typo-figcaption();
        color: $jps-gray-600;
        margin-top: 0.5rem;
      }
    }
  }
    // 画像編集アイコンの位置調整
  :deep(.edit-image-static) {
    position: absolute;
    right: 8px;
    bottom: 4px;
  }
  .list-add-div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 33%;
  }
}
</style>
